import {ReactElement, ReactNode} from "react";

export interface EditorGroupProps {
    children: ReactNode
}

export function EditorGroup(props: EditorGroupProps): ReactElement {
    return (
        <div className="px-6 flex flex-col gap-4 py-6 border-b border-b-gray-2 last:border-b-0">
            {props.children}
        </div>
    );
}

export interface EditorGroupTitleProps {
    children: ReactNode
}

export function EditorGroupTitle(props: EditorGroupTitleProps): ReactElement {
    return (
        <h3 className="uppercase text-sm leading-tight font-fira-sans">
            {props.children}
        </h3>
    );
}